import '../styles/application.scss';
import '../utils/initRailsUJS';
import '../utils/cable';
import ReactOnRails from 'react-on-rails';

import AffiliateCodesIndex from '../components/affiliate_codes/Index';
import AdministratorShow from '../components/administrators/Show';
import Administrators from '../components/administrators/DirectorsIndex';
import AdminHeader from '@reactiveonline/reactive_admin_shared-packages/AdminHeader';
import AdminSidenav from '@reactiveonline/reactive_admin_shared-packages/AdminSidenav';
import BranchesEdit from '../components/branches/Edit';
import CommissionLinesIndex from '../components/commission_lines/Index';
import Dashboard from '../components/dashboard/index';
import Home from '../components/home';
import LanguagePicker from '../components/shared/LanguagePicker';
import OrganizationFees from '../components/organization_fees/Edit';
import OrganizationsIndex from '../components/organizations/index';
import OrganizationsEdit from '../components/organizations/Edit';
import PasswordsEdit from '../components/passwords/Edit';
import PasswordsNew from '../components/passwords/New';
import RegionsEdit from '../components/regions/Edit';
import RegistrationsIndex from '../components/registrations/index';
import RegistrationDetails from '../components/registrations/RegistrationDetails';
import RegistrationsShow from '../components/registrations/Show';
import SessionsNew from '../components/sessions/New';
import SessionsSetPassword from '../components/sessions/SetPassword';
import Settings from '../components/settings';

ReactOnRails.register({
  AdminHeader,
  AdminSidenav,
  AffiliateCodesIndex,
  AdministratorShow,
  Administrators,
  BranchesEdit,
  CommissionLinesIndex,
  Dashboard,
  Home,
  LanguagePicker,
  OrganizationFees,
  OrganizationsIndex,
  OrganizationsEdit,
  PasswordsEdit,
  PasswordsNew,
  RegionsEdit,
  RegistrationsIndex,
  RegistrationDetails,
  RegistrationsShow,
  SessionsNew,
  SessionsSetPassword,
  Settings
});
